<div class="container">

  <!-- NAVBAR -->
  <nav class="navbar  navbar-fixed-top" role="navigation">
   <!-- <a class="navbar-brand" href="#"><img src="/assets/p2.jpg" style="width: 10%; length:10%"></a>-->
    <div class="navbar-header">
      <!--<h1 id="title" class="font-weight-bold text-center">Giovanni Sulli Personal Trainer</h1>-->
    </div>
  </nav></div>
